import {
  CloseButton,
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { memo } from 'react'

import { CloseIcon } from '../../../components/Icons'

interface IModalProps {
  title: string
  open?: boolean
  onClose: () => void
  children: React.ReactNode | React.ReactNode[]
}

const Modal: React.FC<IModalProps> = memo(
  ({ open = true, title, onClose, children }) => {
    const closePopup = () => {
      onClose()
    }
    return (
      <Dialog
        className="relative z-50"
        unmount={false}
        open={open}
        onClose={closePopup}
      >
        <DialogBackdrop className="tc-mv-backdrop" />
        <div className="fixed inset-0 overflow-y-auto h-[var(--vh)] sm:h-screen flex items-center justify-center px-4 sm:px-0">
          <DialogPanel className="tc-mv-popup mx-auto">
            <DialogTitle className="text-lg text-white w-full flex py-4 px-6 border-b border-white/10">
              {title}
              <CloseButton
                onClick={closePopup}
                className="text-white ms-auto opacity-70 hover:opacity-100"
              >
                <CloseIcon />
              </CloseButton>
            </DialogTitle>
            <div>{children}</div>
          </DialogPanel>
        </div>
      </Dialog>
    )
  },
)

export { Modal }
